import 'react-native-gesture-handler';
import { registerRootComponent } from 'expo';
import { Platform } from 'react-native';

// Show something immediately on web so we never see a blank white screen
if (Platform.OS === 'web' && typeof document !== 'undefined') {
  const boot = document.createElement('div');
  boot.id = 'expo-boot-screen';
  boot.setAttribute('style', [
    'position:fixed;inset:0;z-index:99999;',
    'background:#ffffff;',
  ].join(''));
  (document.body || document.documentElement).appendChild(boot);
}

// Global web styles:
if (Platform.OS === 'web' && typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    /* Mobile browser: fit viewport so bottom nav is visible without scroll (100dvh = dynamic viewport height, excludes browser chrome) */
    @media (max-width: 767px) {
      html, body, #root, [data-reactroot] {
        height: 100% !important;
        min-height: 100dvh !important;
        max-height: 100dvh !important;
        overflow: hidden !important;
      }
    }
    iframe[style*="2147483647"] {
      pointer-events: none !important;
    }
    input, textarea {
      outline: none !important;
      -webkit-appearance: none;
      padding-left: 4px !important;
    }
    input:focus, textarea:focus {
      outline: none !important;
      box-shadow: none !important;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0.08) inset, inset 3px 0 0 0 rgba(148, 235, 152, 0.5) !important;
      box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0.08) inset, inset 3px 0 0 0 rgba(148, 235, 152, 0.5) !important;
      -webkit-text-fill-color: #FFFFFF !important;
      caret-color: #FFFFFF !important;
      transition: background-color 5000s ease-in-out 0s !important;
    }
    @media (prefers-color-scheme: light) {
      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus,
      input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.04) inset, inset 3px 0 0 0 rgba(148, 235, 152, 0.5) !important;
        box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.04) inset, inset 3px 0 0 0 rgba(148, 235, 152, 0.5) !important;
        -webkit-text-fill-color: #0A0A0A !important;
        caret-color: #0A0A0A !important;
      }
    }
  `;
  document.head.appendChild(style);
}

// Debug: catch all unhandled errors
if (typeof window !== 'undefined') {
  window.onerror = function(message, source, lineno, colno, error) {
    console.error('🔴 Global error:', message);
    console.error('🔴 Source:', source);
    console.error('🔴 Line:', lineno, 'Col:', colno);
    console.error('🔴 Error object:', JSON.stringify(error, Object.getOwnPropertyNames(error)));
    return false;
  };
  
  window.addEventListener('unhandledrejection', function(event) {
    console.error('🔴 Unhandled promise rejection:', event.reason);
    if (event.reason instanceof Error) {
      console.error('🔴 Stack:', event.reason.stack);
    }
  });
}

console.log('🚀 Starting app initialization...');

let App;
try {
  App = require('./App').default;
  console.log('✅ App module loaded successfully');
} catch (error) {
  console.error('🔴 Failed to load App module:', error.message);
  console.error('🔴 Stack:', error.stack);
  // Remove boot screen so fallback is visible
  if (typeof document !== 'undefined') {
    const boot = document.getElementById('expo-boot-screen');
    if (boot) boot.remove();
  }
  // Create a fallback app that shows the error
  const React = require('react');
  const { View, Text } = require('react-native');
  App = () => React.createElement(View, { style: { flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#1a1a2e', padding: 20 } },
    React.createElement(Text, { style: { color: '#ff6b6b', fontSize: 18, fontWeight: 'bold' } }, 'Failed to load app'),
    React.createElement(Text, { style: { color: '#fff', marginTop: 10 } }, error.message)
  );
}

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
